module.exports = __webpack_public_path__ + "img/1696399566547-kue untir toples j2.jpg.b349738d.webp";